import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = { 
    event: { type: String, default: "homescreen.scroll_to_bottom" },
    referrer: { type: String, default: "frankly5" },
    dailyScheduleId: Number
  };

  connect() {
    this.hasLogged = false;
    this.throttleTimeout = null;
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
    }
  }

  handleScroll() {
    // Throttle scroll events to avoid excessive checking
    if (this.throttleTimeout) {
      return;
    }

    this.throttleTimeout = setTimeout(() => {
      this.throttleTimeout = null;
      this.checkScrollPosition();
    }, 100);
  }

  checkScrollPosition() {
    // Only log once per page load
    if (this.hasLogged) {
      return;
    }

    // Calculate if user has scrolled to the bottom
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    
    // Consider "bottom" as within 50 pixels of the actual bottom
    const threshold = 50;
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    if (distanceFromBottom <= threshold) {
      this.logScrollToBottom();
      this.hasLogged = true;
    }
  }

  async logScrollToBottom() {
    const payload = {
      event: this.eventValue,
      resource_id: this.dailyScheduleIdValue,
      target_type: 'DailySchedule',
      referrer: this.referrerValue
    };

    try {
      await post('/user_activities/activity', {
        body: JSON.stringify(payload)
      });
    } catch (error) {
      console.error('Failed to log scroll activity:', error);
    }
  }
}

